// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlinkingBulb_wrapper__b8XXY","icon":"BlinkingBulb_icon__1tkzQ","overlay":"BlinkingBulb_overlay__2P-dd"};